import _ from 'lodash';
import classNames from 'classnames';
import _map from 'lodash/map';
import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import ComponentContainer from './ComponentContainer';

class Header extends Component {
  static propTypes = {
    FRN_componentInstanceId: PropTypes.string,
    backgroundColor: PropTypes.string,
    menuBackgroundColor: PropTypes.string,
    submenuBackgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    menu: PropTypes.array,
    widget: PropTypes.object
  }

  static contextTypes = {
    flux: PropTypes.object.isRequired,
    config: PropTypes.object.isRequired
  }

  render() {
    const {
      config: {
        affiliate: {
          logo = ''
        } = {},
        header = []
      } = {}
    } = this.context;
    const {
      FRN_componentInstanceId,
      backgroundColor = "#ffffff",
      menuBackgroundColor = "#ffffff",
      submenuBackgroundColor = "#ffffff",
      textColor = "#000000",
      menu: menuItems = [],
      widget: widgetComponentDefinition
    } = this.props;

    const style = { backgroundColor, "color": textColor };
    const menuItemComponents = _map(menuItems, (elem, i) => {
      return (
        <HeaderMenu key={i} item={elem} backgroundColor={menuBackgroundColor} submenuBackgroundColor={submenuBackgroundColor}/>
      );
    });

    //TODO: Get affiliate name for logo alt text

    return (
      <div className="Header header-v5 header-sticky" style={style}>
        <div className="navbar navbar-default mega-menu" role="navigation">
          <div className="container">
            <button type="button" className="navbar-toggle pull-left" data-toggle="collapse" data-target=".navbar-responsive-collapse">
              <span className="sr-only">Toggle navigation</span>
              <span className="fa fa-bars"></span>
            </button>

            <div className="navbar-header">
              <Link to='/' className='navbar-brand'>
                <img id="logo-header" src={ logo } alt="Logo"/>
              </Link>
            </div>
            {widgetComponentDefinition ? (
              <div className="shop-badge badge-icons pull-right">
                <ComponentContainer
                  componentDefinition={widgetComponentDefinition}
                  // NOTE: Remove once we deprecate all object header's.
                  componentInstanceId={_.isArray(header) ? `${FRN_componentInstanceId}.props.widget` : 'header.widget'}
                />
              </div>
            ) : null}
            <div className="navbar-collapse mega-menu navbar-responsive-collapse collapse" aria-expanded="true">
              <ul className="nav navbar-nav">
                { menuItemComponents }
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class HeaderMenu extends Component {
  static propTypes = {
    item: PropTypes.object.isRequired,
    submenu: PropTypes.bool,
    backgroundColor: PropTypes.string.isRequired,
    submenuBackgroundColor: PropTypes.string.isRequired,
    indent: PropTypes.number
  }

  static defaultProps = {
    item: {},
    submenu: false,
    backgroundColor: "#ffffff",
    submenuBackgroundColor: "#ffffff",
    indent: 0
  }

  render() {
    const { item: { text, href, menu },
      submenu,
      backgroundColor,
      submenuBackgroundColor} = this.props;

    let { indent } = this.props;
    indent++;

    const style = { backgroundColor };
    const styleHeaderSub = { backgroundColor };


    const menuItemComponents = _map(menu, (item, i) => {
      return (
        <HeaderMenu key={i} item={item} submenu backgroundColor={submenuBackgroundColor} submenuBackgroundColor={backgroundColor}/>
      );
    });

    const componentClassName = classNames(
      'HeaderMenu',
      {
        'dropdown': menuItemComponents.length && !submenu,
        'dropdown-submenu': menuItemComponents.length && submenu
      });

    /*eslint-disable no-script-url*/
    const menuLink = submenu ?
      <a className="HeaderMenu-link" href="javascript: void(0);" style={styleHeaderSub}>{text}</a> :
      <a className="HeaderMenu-link HeaderMenu-top dropdown-toggle" data-toggle="dropdown" aria-expanded="false" style={style}>{text}</a>;
    /*eslint-enable no-script-url*/

    return (
      <li className={componentClassName} >
        { menuItemComponents.length ? menuLink : <a className="HeaderMenu-link HeaderMenu-top" href={href} style={style}>{text}</a> }

        { menuItemComponents.length ?
          <ul className="dropdown-menu" style={style}>
            {menuItemComponents}
          </ul> : null}
      </li>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./app/components/core/Header.js